// Regex helpers for extracting trait/enrichment references from Liquid templates
// Keep this file clean of backend imports since this is used in the UI.

function defined(xs: (string | undefined)[]): string[] {
  return xs.filter((x): x is string => x !== undefined);
}

export function getParentTraitsFromTemplate(template: string): string[] {
  // Note: dot notation is not supported for parent traits, only single and double quotes
  return defined(
    Array.from(
      template.matchAll(
        /(\btraits\['[^']*:[^']*'\])|(\btraits\["[^"]*:[^"]*"\])/g,
      ),
      (m) => m[1] ?? m[2] ?? m[3],
    ),
  );
}

export function getParentTraitReferences(trait: string): string[] {
  return defined(
    Array.from(
      trait.matchAll(
        /\btraits\['([^']*:[^']*)'\]|\btraits\["([^"]*:[^"]*)"\]/g,
      ),
      (m) => m[1] ?? m[2] ?? m[3],
    ),
  );
}

export function getTraitEnrichmentsFromTemplate(template: string): string[] {
  return defined(
    Array.from(
      template.matchAll(
        /(trait_enrichments\['[^']*'\])|(trait_enrichments\["[^"]*"\])|(trait_enrichments\.[^.\s]+)/g,
      ),
      (m) => m[1] ?? m[2] ?? m[3],
    ),
  );
}

export function getTraitEnrichmentReferences(trait: string): string[] {
  return defined(
    Array.from(
      trait.matchAll(
        /trait_enrichments\['([^']*)'\]|trait_enrichments\["([^"]*)"\]|trait_enrichments\.([^.\s]+)/g,
      ),
      (m) => m[1] ?? m[2] ?? m[3],
    ),
  );
}

// this is borrowed from `getColumnsFromTemplate` in `row.ts`, but includes the `traits[]` part
// `traits['foo'] + traits["bar"] + traits.baz` => ["traits['foo']", "traits["bar"]", "traits.baz"]
export function getTraitEnrichmentsFromTemplateLegacy(
  template: string,
): string[] {
  /*  Note: we exclude the colon : from possible matches, because that is new syntax for
   * 'parent traits' -> which are listed in template as `${traitName}:${traitId}`
   * legacy 'traits' are actually trait_enrichments, when they are just a trait name, without a : + uuid
   *
   **/
  return defined(
    Array.from(
      template.matchAll(
        /(\btraits\['[^':]*'\])|(\btraits\["[^":]*"\])|(\btraits\.[^.\s]+)/g,
      ),
      (m) => m[1] ?? m[2] ?? m[3],
    ),
  );
}

export function getTraitEnrichmentReferencesLegacy(trait: string): string[] {
  //Matches the patterns inside quotes, and do not contain colons
  // See note above on legacy behavior, and TODO in getTraitEnrichmentsFromTemplateLegacy
  return defined(
    Array.from(
      trait.matchAll(
        /\btraits\['([^':]*)'\]|\btraits\["([^":]*)"\]|\btraits\.([^.\s]+)/g,
      ),
      (m) => m[1] ?? m[2] ?? m[3],
    ),
  );
}
